import { render, staticRenderFns } from "./AssignedQuizzesCards.vue?vue&type=template&id=888d950e&scoped=true"
import script from "./AssignedQuizzesCards.vue?vue&type=script&lang=js"
export * from "./AssignedQuizzesCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888d950e",
  null
  
)

export default component.exports